// extracted by mini-css-extract-plugin
module.exports = {"wrap":"bj","contentWrapCtaDefault":"cj","disabled":"dj","contentWrapCtaWhite":"ej","promos":"fj","lazyPromo":"gj","mainContent":"hj","headingText":"ij","copy":"jj","subtext":"kj"};